/*
  🦾 Custom toggle by BoostEcom
  ➕ Gère l'ajout/retrait du produit upsell via toggle switch dans le cart drawer
  🔒 Ne pas toucher
  ⚠️ Mise à jour effectuée le 20 mars 2026 par @Christopher Lasgi

  Problème : Pas de mécanisme one-click pour les produits cross-sell dans le cart.
  Solution : Toggle switch qui appelle l'API Cart AJAX (add/change) au clic.

  Import : <script src="{{ 'custom-toggle_boostecom.js' | asset_url }}" defer></script>
  Dépendances : snippets/custom-toggle_boostecom.liquid (HTML du switch)
*/
(function () {
  const w = /** @type {any} */ (window);
  if (w.__beToggleBound__) return;
  w.__beToggleBound__ = true;

  const shopify = /** @type {any} */ (window.Shopify);

  const root =
    (shopify && shopify.routes && shopify.routes.root) ||
    "/";

  const buildSectionsParam = () => {
    const set = new Set();
    document.querySelectorAll("[data-section-id]").forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      set.add(el.getAttribute("data-section-id"));
    });
    document
      .querySelectorAll("cart-items-component,[data-cart-section-id]")
      .forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        if (el.dataset?.sectionId) set.add(el.dataset.sectionId);
        if (el.dataset?.cartSectionId) set.add(el.dataset.cartSectionId);
      });

    if (set.size === 0) {
      ["cart-items", "cart-icon-bubble", "cart-live-region-text", "cart-footer"].forEach((id) =>
        set.add(id)
      );
    }

    return Array.from(set).filter(Boolean).join(",");
  };

  const sectionsUrl = () =>
    window.location.pathname.startsWith("/")
      ? window.location.pathname
      : "/" + window.location.pathname;

  const pending = new Set();

  const fetchCart = async () => {
    const response = await fetch(root + "cart.js?t=" + Date.now(), {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Cart fetch failed");
    return response.json();
  };

  /**
   * @param {{ item_count?: number } | null} cart
   * @param {Record<string, string> | undefined} sections
   */
  const dispatchCartUpdate = (cart, sections) => {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            source: "custom-toggle_boostecom",
            itemCount: Number(cart?.item_count || 0),
            sections: sections || {},
          },
        },
      })
    );
  };

  /** @param {Event} evt */
  document.addEventListener("change", async (evt) => {
    const el = evt.target;
    if (!(el instanceof HTMLInputElement) || !el.matches('[id^="productCheckbox-"]')) return;

    const variantIdStr = el.id.replace("productCheckbox-", "").trim();
    if (!variantIdStr || pending.has(variantIdStr)) return;

    const variantIdNum = parseInt(variantIdStr, 10);
    const isAdding = el.checked;
    const sections = buildSectionsParam();
    const sections_url = sectionsUrl();

    pending.add(variantIdStr);
    el.disabled = true;

    try {
      if (isAdding) {
        const body = {
          items: [{ id: variantIdNum, quantity: 1 }],
          sections,
          sections_url,
        };

        const res = await fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Cart add failed");

        const data = await res.json();
        const cart = await fetchCart();
        dispatchCartUpdate(cart, data.sections);
      } else {
        const cart = await fetchCart();

        const item = cart.items.find((/** @type {{ variant_id: number }} */ i) => Number(i.variant_id) === variantIdNum);
        if (!item) return;

        const body = { id: item.key, quantity: 0, sections, sections_url };

        const res = await fetch(root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Cart change failed");

        const data = await res.json();
        const freshCart = await fetchCart();
        dispatchCartUpdate(freshCart, data.sections);
      }
    } catch (err) {
      console.error("Erreur toggle upsell:", err);
      el.checked = !isAdding;
    } finally {
      pending.delete(variantIdStr);
      el.disabled = false;
    }
  });
})();

/*
  © 2026 CustomToggle. Tous droits réservés.
  Créé avec ❤️ par Christopher Lasgi pour les développeurs Shopify (OS 3.0).

  Mais ATTENTION :

  ⚠️ Pas pour les curieux. Ici on bosse.

  Tous les livrables dans ce service sont des créations originales protégées par l'écosystème « BoostEcom » (art. L111‑1 et suivants du Code de la propriété intellectuelle).

  En achetant mes services, tu obtiens une licence d'utilisation NON‑exclusive, NON‑transférable et NON‑cessionnable :

  ✔️ Usage illimité sur ta (tes) boutique(s) Shopify.
  ❌ Interdiction de revendre, copier, republier ou distribuer tout ou partie de ces livrables, même modifiés.
  ❌ Interdiction de créer un service "clone" ou d'en réutiliser la description (Shopify bannit la duplication).

  **Tout manquement déclenchera :**

  1. Plainte DMCA / retrait Shopify, conformément aux CGU (section 6, "contenu original").
  2. Facturation immédiate d'une pénalité équivalente à 3× le prix public.
  3. Action judiciaire en contrefaçon si nécessaire.
  4. Et l'envoi d'une armée de méchants robots à ta poursuite… (je plaisante 😅).

  Merci de respecter mon travail, créons plutôt ensemble des écosystèmes e‑commerce qui cartonnent ! ✌️
*/
